@if (visible()) {
	<mat-paginator
		class="list-paginator"
		[length]="length()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[hidePageSize]="hidePageSize()"
		[disabled]="disabled()"
		(page)="pageChange.emit($event)"
	/>
}
